/* eslint-disable
    @typescript-eslint/no-this-alias,
    eqeqeq,
    @typescript-eslint/no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Auth } from 'app/scripts/db/Auth';
import { Util } from 'app/scripts/lib/util';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/view';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PopoverEmojiUploaderTemplate } from 'app/scripts/views/templates/PopoverEmojiUploaderTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface EmojiUploaderView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  canUpload: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  completerView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class EmojiUploaderView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'viewTitleKey' does not exist on type 'Em... Remove this comment to see the full error message
    this.prototype.viewTitleKey = 'upload emoji';
  }

  events() {
    return {
      'click .js-upload-emoji': 'uploadEmoji',
      'change .js-upload-emoji-file': 'fileChange',
      'input .js-emoji-name': 'nameChange',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ completerView }: any) {
    this.completerView = completerView;
    this.canUpload = true; // customEmoji is now a free feature
  }

  render() {
    const data = this.model.toJSON();
    data.emojiName = this.options.emojiName;
    data.canUpload = this.canUpload;

    this.$el.html(templates.fill(PopoverEmojiUploaderTemplate, data));

    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    this._validate();
    this.renderEmoji();

    return this;
  }

  getName() {
    return (
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      $('.js-emoji-name', this.$el)
        .val()
        // @ts-expect-error TS(2339): Property 'trim' does not exist on type 'string | n... Remove this comment to see the full error message
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
    );
  }

  renderEmoji() {
    $('.js-emoji-preview-name', this.$el).text(`:${this.getName() || '???'}:`);

    // eslint-disable-next-line @trello/enforce-variable-case
    const $file = $('.js-upload-emoji-file', this.$el);
    const file = $file.prop('files')?.[0];
    if (new RegExp(`^image/.*`).test(file != null ? file.type : undefined)) {
      const reader = new FileReader();
      reader.onload = (file) => {
        $('.js-emoji-conversion', this.$el).removeClass('hide');
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        return $('.js-emoji-preview', this.$el).attr('src', file.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      $('.js-emoji-conversion', this.$el).addClass('hide');
    }

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fileChange(e: any) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $name = $('.js-emoji-name', this.$el);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $file = $('.js-upload-emoji-file', this.$el);
    if ($name.val() === '') {
      let name;
      const file = $file.prop('files')?.[0];
      if (file != null) {
        ({ name } = file);
      } else if ($file.val()) {
        // Proably IE, try to get the file from the path
        // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
        name = new RegExp(`[^\\/]+$`).exec($file.val())?.[0];
      }

      if (name == null) {
        name = '';
      }
      name = name.split('.')[0]; // Remove the extension(s)
      name = name.toLowerCase().replace(/[^a-z0-9_]/g, '');

      $name.val(name);
      $('.js-emoji-name', this.$el).focus().select();
    }

    this.renderEmoji();
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    return this._validate();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nameChange(e: any) {
    this.renderEmoji();
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    return this._validate();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _validate(e: any) {
    const name = this.getName();

    // eslint-disable-next-line @trello/enforce-variable-case
    const $file = $('.js-upload-emoji-file', this.$el);

    const nameValid = /^[a-z0-9_\s]+$/.test(name);
    const fileValid = $file.prop('files')?.length > 0 || $file.val();
    const valid = nameValid && fileValid && this.canUpload;

    $('.js-invalid-name', this.$el).toggleClass(
      'hide',
      nameValid || name === '',
    );
    return $('.js-upload-emoji', this.$el).toggleClass('disabled', !valid);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uploadEmoji(e: any) {
    stopPropagationAndPreventDefault(e);
    if ($('.js-upload-emoji').hasClass('disabled')) {
      return;
    }

    $('.error', this.$el).addClass('hide');

    // eslint-disable-next-line @trello/enforce-variable-case
    const $file = $('.js-upload-emoji-file', this.$el);
    const file = $file.prop('files')?.[0];
    const name = this.getName();

    const onSuccess = () => {
      this.completerView.insertEmoji(name);
      return PopOver.hide();
    };

    if (!file && $file.val()) {
      // Yuck, it's IE.  Let's submit the form.
      Util.uploadFile(Auth.myToken(), $file, onSuccess);
      return;
    }

    if (file != null && !Util.validFileSize(file)) {
      Alerts.flash('file too large', 'error', 'emoji-uploader');
      return;
    }

    if (file == null || !name) {
      return;
    }

    const reader = new FileReader();
    const fd = new FormData();
    fd.append('token', Auth.myToken());
    fd.append('file', file);
    fd.append('name', name);
    const idOrganization = this.options.card?.getBoard()?.getOrganization()?.id;
    if (idOrganization) {
      fd.append('idOrganization', idOrganization);
    }

    reader.onload = (file) => {
      return this.model.customEmojiList.create(
        {
          // @ts-expect-error TS(2531): Object is possibly 'null'.
          url: file.target.result,
          name,
        },
        {
          data: fd,
          processData: false,
          contentType: false,
          success: onSuccess,
          error() {
            return $('.error', this.$el).removeClass('hide');
          },
        },
      );
    };

    return reader.readAsDataURL(file);
  }
}

EmojiUploaderView.initClass();
export { EmojiUploaderView };
